module.exports = __webpack_public_path__ + "img/36.14232f0b.jpg";